import { Avatar } from '@material-ui/core';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React from 'react';
import { transl } from '../main/transl';
import { commSvc } from '../services/CommSvc';
import { useOmnistore } from '../stores/Omnistore';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			marginLeft:'15px',
			marginRight: '5px'
		},
		paper: {
			marginRight: theme.spacing(2),

		},
		popper:{
			top: '12px !important',
			'& .MuiListItem-button': {
				flexDirection: 'column',
				fontSize: '16px',
				alignItems: 'flex-start'
			},
			'& .MuiListItem-button:first-child':{
				marginBottom: '13px'
			}
		},
		avtar:{
			backgroundColor: '#ce0058',
			fontWeight:700,
			cursor:'pointer'
		},
		profileInfo:{
			fontSize: '11px'
		}
	}),
);

interface IMainpanelMenuProps {
	userNameLetters: string;
	userEmail: string;
	showProfilePage: () => void;
}

export function MainpanelMenu(props: IMainpanelMenuProps ) {
	const classes = useStyles('');
	const [open, setOpen] = React.useState(false);
	const anchorRef = React.useRef<HTMLDivElement>(null);
	const router = useOmnistore().locationStore;

	const handleToggle = () => {
		setOpen(prevOpen => !prevOpen);
	};

	const handleClose = (event: React.MouseEvent<EventTarget>) => {
		if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
			return;
		}
		setOpen(false);
	};

	const setProfilePage = (event) => {
		props.showProfilePage();
		handleClose(event);
	};

	const logout = (event) => {
		router.setPage('GDashboard');
		commSvc.logout();
		handleClose(event);
	};

	function handleListKeyDown(event: React.KeyboardEvent) {
		if (event.key === 'Tab') {
			event.preventDefault();
			setOpen(false);
		}
	}

	// return focus to the button when we transitioned from !open -> open
	const prevOpen = React.useRef(open);
	React.useEffect(() => {
		if (prevOpen.current === true && open === false) {
            anchorRef.current!.focus();
		}

		prevOpen.current = open;
	}, [open]);

	return (
		<div className={classes.root}>
			<div>
				<Avatar ref={anchorRef}
					aria-controls={open ? 'menu-list-grow' : undefined}
					aria-haspopup="true"
					onClick={handleToggle}
					className={classes.avtar}>{props.userNameLetters}</Avatar>

				<Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal className={classes.popper} placement={'bottom-end'}>
					{({ TransitionProps }) => (
						<Grow
							{...TransitionProps}
							style={{ transformOrigin: 'center top' }}
						>
							<Paper square={true}>
								<ClickAwayListener onClickAway={handleClose}>
									<MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
										<MenuItem onClick={setProfilePage}>{transl('MyProfile')}<span className={classes.profileInfo}>{props.userEmail}</span></MenuItem>
										<MenuItem onClick={logout}>{transl('action.logout')}</MenuItem>
									</MenuList>
								</ClickAwayListener>
							</Paper>
						</Grow>
					)}
				</Popper>
			</div>
		</div>
	);
}
